import { fetchWrapper } from '../Helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}/offers`;

export const offerService = {
  getAll,
  getOfferDetailsByOfferId,
  getOfferByOrderId,
  getApplicationData,
  setOfferActions
};
function getAllPaging(options, filterString) {
  filterString += filterString.length > 0 ? `&` : '';
  filterString += `page=${options.page}`;
  if (options.pageSize) {
    filterString += filterString.length > 0 ? `&` : '';
    filterString += `per_page=${options.pageSize}`;
  }
  return filterString;
}
function getAll(options) {
  let filterString = '';
  if (options.filter) {
    filterString = options.filter;
  }
  if (options.page !== undefined) {
    filterString = getAllPaging(options, filterString);
  }
  const url =
    filterString.length > 0 ? `${baseUrl}?${filterString}` : `${baseUrl}`;
  return fetchWrapper.get(url);
}
function getOfferByOrderId(id) {
  return fetchWrapper.get(
    `${baseUrl}/offersByOrderId/${id}`
  );
}
function getOfferDetailsByOfferId(id) {
  return fetchWrapper.get(
    // `${baseUrl}/offerDetailsByOfferId/${id}`
    `${baseUrl}/${id}`
  );
}

function getApplicationData(application_id) {
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_URL}/applications/${application_id}`
  );
}

function setOfferActions(id, action ) {
    return fetchWrapper.post(`${baseUrl}/${id}/${action}`, {});
}